module.exports = __webpack_public_path__ + "img/img-7.6d05697d.jpg";